import { render, staticRenderFns } from "./Rewards-pending.vue?vue&type=template&id=508a7d56&scoped=true"
import script from "./Rewards-pending.vue?vue&type=script&lang=js"
export * from "./Rewards-pending.vue?vue&type=script&lang=js"
import style0 from "./Rewards-pending.vue?vue&type=style&index=0&id=508a7d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a7d56",
  null
  
)

export default component.exports